<template>
  <v-app>
    <v-system-bar
      app
      color="primary"
      dark
    >
    {{text.appTitle}}<span v-if="!disUsermenu">|<a href="./manual.pdf" target="_blank" style="color:#FFF">{{text.manualA}}</a></span>
      <v-spacer></v-spacer>
      <v-menu offset-y="true" fixed absolute>
        <template v-slot:activator="{on}">
          <span v-on="on" class="hoverPointer"><v-icon>mdi-account</v-icon>{{username}}</span>
        </template>
        <v-list dense>
          <v-list-item :disabled="disUsermenu" @click="logout">{{text.logout}}</v-list-item>
          <v-divider></v-divider>
          <v-list-item :disabled="disUsermenu" @click="chgPassword">{{text.chgPassword}}</v-list-item>
          <v-list-item :disabled="disUsermenu" @click="setTotp">{{text.setTotp}}</v-list-item>
        </v-list>
      </v-menu>
    </v-system-bar>

    <v-main>
      <div v-if="!initialLoading && !apiConFail">
        <Login ref="refLogin" @parentCall="appCall" v-if="components.login.display"/>
        <Admin ref="refAdmin" @parentCall="appCall" v-if="components.admin.display"/>
        <Main ref="refMain" @parentCall="appCall" v-if="components.main.display"/>
      </div>
      <div v-if="initialLoading">
        読み込み中
      </div>
      <div v-if="apiConFail">
        Server connection failed.<br>
        サーバーに接続できません。<br>
      </div>
    </v-main>
    <PassworChg ref="refPassChg" @parentCall="appCall" :userData="userData" />
    <v-snackbar id="appSnackBar" class="pa-0" top vertical :color="systemMessegeSnack.color" v-model="systemMessegeSnack.show" :timeout="systemMessegeSnack.timeout" transition="v-expand-x-transition">
      <v-container class="d-flex flex-row">
        <v-icon v-show="systemMessegeSnack.timeout<0" @click="systemMessegeSnack.show=false">mdi-close-circle</v-icon>
        {{systemMessegeSnack.text}}
      </v-container>
    </v-snackbar>
    <v-dialog max-width="600px" overlay-opacity="0.8" :persistent="systemMessege.persistent" v-model="systemMessege.show">
      <v-alert :color="systemMessege.color">
        <span v-html="systemMessege.text"></span>
      </v-alert>
    </v-dialog>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate></v-progress-circular>
      {{text.loading}}
    </v-overlay>
  </v-app>
</template>

<script lang="ts">
  import Vue from 'vue';
  import Login from './components/login.vue';
  import Admin from './components/admin.vue';
  import Main from './components/main.vue';
  import PassworChg from './components/password.vue';
  import {apiRequest} from "./lib/api";
  const api = new apiRequest({
    "headerPrefix":"ogi",
    "saver":{
      "host":`${(new URL(document.URL)).origin}/pl/_api`,
      "clientAuthPoint":"/api/v1/auth/client",
      "keyExchangePoint":"/api/v1/keyex",
      "ottEndPoint":"/api/v1/ott",
      "cert":{"kty":"EC","crv":"P-521","key_ops":["verify"],"ext":true,"x":"AGMIZ65iGbEv1FSOKLRpYsN0dKuO-higEEsKj8PvHXWEkCPS06QXTSpJH8ea4B-fdjW7Y911iXRind5TEN5_Yii9","y":"AI6JSyqe_zWfqvSSh6Wh3m8uoy_DcgWiO-Z8dikVk2OPnkbLz2GqXjYWSdu5C4f7zYnPROj--YjbA7nNSIzkXGmA"},
      "cryptoParamerter":"ECDH_P-521,AES-GCM_256,ECDSA_P-521_SHA521",
    },
    "client":{
            "clientId":"spa",
            "clientSecret":"Myrehs0c0WJ0mg5GMrI9Qa5zZt7xJETP",
      }
  });
  import {indexDb} from "./lib/indexDbStore";
  const db = new indexDb();
  import * as comm from './common';
  import * as type from './types';
  import {reConnectParamerter} from "./lib/api/securesession/keyEx";
  import lang from "./lang";

  let text = new lang(0);
  interface vueAdd extends Vue{
    parentCallback:(messege:string)=>void;
  }
  interface vueRefForm extends Vue{
    validate:()=>boolean;
  }
  interface passwordChgComponent extends Vue{
    chgPassword:()=>void;
    setTotp:()=>void;
  }

  let componentList = {
    login:{display:true} as type.component,
    admin:{display:false} as type.component,
    main:{display:false} as type.component,
  }
  export default Vue.extend({
    name: 'App',

    components: {
      Login,
      Admin,
      Main,
      PassworChg,
    },

    data: () => ({
      text:text.Text,
      api:null as null|{connection:boolean,apiRequest:null|apiRequest},
      apiConFail:false,
      initialLoading:true,
      disPasswordChgBtn:false,
      showP:false,
      showQ:false,
      passwordWarning:"",
      activateFail:false,
      disActTotoBtn:false,
      activateComplete:false,
      passwordScoreTxt:"",
      components:componentList,
      username:"",
      password:"",
      currentPassword:"",
      newPassword:"",
      newPasswordV:"",
      newPassChk:{
        error:false,
        errMes:"",
      },
      totpKey:"",
      otpToken:"",
      activateToken:"",
      totpQrCode:null as null|string|Blob,
      userData:{} as type.userData,
      digTotpInfo:false,
      disUsermenu:true,
      digTotpSet:false,
      digClearTotp:false,
      digChangePassword:false,
      loading:false,
      systemMessege:{
        show:false,
        color:"red",
        text:"TEXT",
        timeout:1500,
        persistent:false,
      },
      systemMessegeSnack:{
        show:false,
        color:"red",
        text:"TEXT",
        timeout:1500,
        persistent:false,
      },
    }),
    mounted(){
      this.initApiCon();
      const snackBarElm = document.getElementById('appSnackBar');
      if(snackBarElm && snackBarElm.children[0]){
        const sElm = snackBarElm.children[0];
        sElm.addEventListener("click",()=>{this.eatSnackBar()});
      }
    },
    methods:{
      reset(){
          //@ts-ignore
          Object.assign(this.$data,this.$options.data());
      },
      setUserInfo(){
        this.userData = this.$store.state.user;
            this.components.login.display = false;
            this.username = this.userData.userName;
            this.disUsermenu = false;
            if(this.userData.administrator){
              this.components.admin.display = true;
              setTimeout(this.showAdminPage,1);
            }else{
              this.components.main.display = true;
              setTimeout(this.showMainPage,1);
            }
            if(this.userData.lastLogin){
              comm.SnackbarMessege(this,`${this.text.messege.lastLogin}:${comm.formatDate(new Date(this.userData.lastLogin),'mm/dd HH:MM:SS')}`,'#2196F3',true,10000);
            }
      },
      appCall(order:string){
        switch(order){
          case "authScces":
            //ログインOK
            this.setUserInfo();
          break;
          case "systemMessege":
            this.systemMessege.color = this.$store.state.systemMessege.color;
            this.systemMessege.text = this.$store.state.systemMessege.text;
            if(this.$store.state.systemMessege.timeout < 0){
              this.systemMessege.persistent = false;
            }else if(this.$store.state.systemMessege.timeout > 0){
              this.systemMessege.persistent = false;
              setTimeout(()=>{this.systemMessege.show = false},this.$store.state.systemMessege.timeout)
            }else{
              this.systemMessege.persistent = false;
              setTimeout(()=>{this.systemMessege.show = false},5000)
            }
            this.systemMessege.show = true;
          break;
          case "systemMessegeSnack":
            this.systemMessegeSnack.color = this.$store.state.systemMessege.color;
            this.systemMessegeSnack.text = this.$store.state.systemMessege.text;
            this.systemMessegeSnack.timeout = this.$store.state.systemMessege.timeout;
            this.systemMessegeSnack.show = true;
          break;
          case "loadingON":
            this.loading = true;
          break;
          case "loadingOFF":
            this.loading = false;
          break;
          case "invalidSession":
            //セッションが無効
            this.sessionClear();
          break;
          case "logout":
            this.logout();
            break;
        }
      },
      async initApiCon(){
        let connect = false;
        const dbSession = await db.session.where("name").equals("sessionId").toArray();
        if(dbSession.length > 0 && typeof dbSession[0].value === "string"){
          //indexedDBにセッション情報が保管されている
          const sessionKey = await db.session.where("name").equals(`session_${dbSession[0].value}`).toArray();
          if(sessionKey.length > 0 && typeof sessionKey[0].value === "string"){
            //セッションIDに対応する再接続情報があるので再接続を試みる
            try{
              const reConnectParam = JSON.parse(sessionKey[0].value) as reConnectParamerter;
              connect = await api.connect({reConnect:reConnectParam});
              await db.session.where("name").startsWith("session").delete();
              if(connect){
                //再接続OK
                const curSession = api.getSessionData();
                if(curSession){
                  await db.session.put({"name":"sessionId","value":curSession.sessionId});
                  await db.session.put({"name":`session_${curSession.sessionId}`,"value":JSON.stringify(curSession.reConnectParamerter)});
                }
              }else{
                connect = await api.connect();
              }
            }catch{
              connect = await api.connect();
            }
          }else{
            db.session.where("name").startsWith("session").delete();
            connect = await api.connect();
          }
        }else{
          connect = await api.connect();
        }
        this.initialLoading = false;
        if(connect){
          this.$store.state.apiSaver.connection = true;
          this.$store.state.apiSaver.apiRequest = null;
          this.$store.state.apiSaver.apiRequest = api;
          this.api = this.$store.state.apiSaver;
          const sessionData = await api.request.session();
          const reConnect = api.getSessionData();
          if(reConnect){
            this.updateSessionDb(reConnect.sessionId,reConnect.reConnectParamerter);
          }
          if(sessionData.statusCode === 200){
            if(sessionData.data.status){
              this.$store.commit("setUser",{
                  "userId":sessionData.data.userData.userid,
                  "userName":sessionData.data.userData.username,
                  "administrator":sessionData.data.userData.administrator,
                  "totp":sessionData.data.userData.otpCode,
                  "lastLogin":null,
                  "tpdata":sessionData.data.userData.tpdata,
                  "flags":sessionData.data.userData.flags,
              });
              this.setUserInfo();
            }
          }else{
            this.$store.commit("clearsession",{});
          }
        }else{
          this.apiConFail = true;
        }
      },
      async updateSessionDb(sessionId:string,reConnectionKey:reConnectParamerter){
        await db.session.where("name").equals("sessionId").delete();
        await db.session.where("name").startsWith("sessionId_").delete();
        await db.session.put({"name":"sessionId","value":sessionId});
        await db.session.put({"name":`session_${sessionId}`,"value":JSON.stringify(reConnectionKey)});
      },
      async sessionClear(){
        await db.session.where("name").equals("sessionId").delete();
        await db.session.where("name").startsWith("sessionId_").delete();
        this.reset();
        if(this.components.admin.display && this.components.admin.vue){
          this.components.admin.vue.parentCallback("reset");
          this.components.admin.display = false;
        }
        if(this.components.main.display && this.components.main.vue){
          this.components.main.vue.parentCallback("reset");
          this.components.main.display = false;
        }
        this.$store.commit("setUser",{
            "userId":"",
            "userName":"",
            "administrator":false,
        });
        this.components.login.display = true;
        comm.WaringMessege(this,this.text.messege.invalidSession,null,true);
        setTimeout(()=>{
          this.reset();
          this.initApiCon();
        },3000)
      },
      async logout(){
        if(this.api && this.api.connection && this.api.apiRequest){
          const result = await this.api.apiRequest.request.desSession();
          if(result.data){
            if(this.components.admin.display && this.components.admin.vue){
              this.components.admin.vue.parentCallback("reset");
              this.components.admin.display = false;
            }
            if(this.components.main.display && this.components.main.vue){
              this.components.main.vue.parentCallback("reset");
              this.components.main.display = false;
            }
            this.$store.commit("setUser",{
                "userId":"",
                "userName":"",
                "administrator":false,
            });
            this.components.login.display = true;
            this.reset();
            this.initApiCon();
          }else{
            comm.ApiErrorMessege(this,{"httpStatus":1,"code":1});
          }
        }else{
            comm.ApiErrorMessege(this,{"httpStatus":1,"code":1});
        }
      },
      showAdminPage(){
        this.components.admin.vue = this.$refs.refAdmin as vueAdd;
        if(this.components.admin.vue){
          this.components.admin.vue.parentCallback('pageShow');
        }
      },
      showMainPage(){
        this.components.main.vue = this.$refs.refMain as vueAdd;
        if(this.components.main.vue){
          this.components.main.vue.parentCallback('pageShow');
        }
      },
      chgPassword(){
        const passchgComp = this.$refs.refPassChg as passwordChgComponent;
        passchgComp.chgPassword();
      },
      setTotp(){
        const passchgComp = this.$refs.refPassChg as passwordChgComponent;
        passchgComp.setTotp();
      },
      eatSnackBar(){
        this.systemMessegeSnack.show = false;
      }
    }
  });

</script>
<style>
.hoverPointer:hover{
  cursor: pointer;
}
</style>
